<template>
    <div id="contents" class="contents contents-other">
        <div class="breadcrumb">
            <ul>
                <li><router-link :to="{name: 'Index'}">TOP</router-link></li>
                <li>Privacy Policy</li>
            </ul>
        </div>

        <h1 class="ttl">Privacy Policy</h1>

        <div class="box-section -grayBgStart">
            <div class="inner">
                <h3 class="ttlSub" id="goInfo">Privacy Policy of the Japan Heritage Official Website</h3>
                <h4 class="ttlSubSub" id="goInfo">1. Basic Stance</h4>
                <p class="para">
                    <a href="https://www.japan.travel/japan-heritage/">The Japan Heritage Official Site</a> (hereafter referred to as “this website”) is provided under the domain “japan.travel” (Registrant Organization: Japan National Tourist Organization) and operated by the Agency for Cultural Affairs of Japan.
                    The Agency for Cultural Affairs collects necessary  information on anyone visiting this website  for the purpose of the smooth operation of the services (such as information provision) provided by this website. The information collected is used appropriately within the scope of the purpose of use.
                </p>

                <h4 class="ttlSubSub" id="goInfo">2. Scope of Information to be Collected</h4>
                <p class="para">This website automatically collects and stores Internet domain names,
                    IP addresses, information about access to this website (i.e., the date
                    and time you access this website and the pages you visit) etc. Cookies
                    (information transmitted from the server to the user's browser and
                    stored on the user's computer in order for the server to identify
                    users) may be used to the purposes to figure out the accurate number
                    of accesses and to improve convenience of the browser display
                    function. Collected user data is not personally identifiable. Users
                    may change their browser's settings so as to disable cookies.
                    Disabling cookies does not affect your browsing of this website.</p>

                <h4 class="ttlSubSub" id="goInfo">3. Purpose of Use</h4>
                <p class="para">The information collected as in 2 is used as a reference for the smooth operation of the services provided by this website.</p>

                <h4 class="ttlSubSub" id="goInfo">4. Restriction of Usage and Provision</h4>
                <p class="para">
                    The Agency for Cultural Affairs will not use collected information for any purpose other than those described in 3 above nor provide such information to Third Parties. This provision, however, shall not apply if there is a mandatory request for disclosure with a legal basis;
                    if there have been illegal activities, such as unauthorized access and blackmailing; or if there are other special reasons. However, statistical information regarding access to this website or non-identifying information on users’ attributes may be made public.
                </p>

                <h4 class="ttlSubSub" id="goInfo">5. Security Measures</h4>
                <p class="para">The Agency for Cultural Affairs will take necessary measures to prevent the leakage, loss, and damage of personal information collected. Any outside party involved in the operation of this website will also take the necessary measures to appropriately manage the information collected.</p>

                <h4 class="ttlSubSub" id="goInfo">6. Scope</h4>
                <p class="para">This Privacy Policy applies solely to information collected by <a href="https://www.japan.travel/japan-heritage/">this website</a>.</p>

                <h4 class="ttlSubSub" id="goInfo">7. Other</h4>
                <p class="para">The Agency for Cultural Affairs may amend this Privacy Policy as necessary.</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PrivacyPolicy",
        created: function() {
            document.title = 'Privacy Policy | Japan Heritage Official Site'
        }
    }
</script>

<style src="./PrivacyPolicy.scss" lang="scss" scoped />
